import React from 'react';
import { Button as MuiButton } from '@mui/material';

type TButton = {
  children: React.ReactNode;
  onClick: () => void;
  color?: 'success' | 'error';
  width?: string;
  variant?: 'contained' | 'outlined';
  size?: 'small' | 'medium';
};

export const Button = ({
  children,
  onClick,
  color,
  width = '87px',
  variant = 'contained',
  size = 'small',
}: TButton) => {
  return (
    <MuiButton
      onClick={onClick}
      variant={variant}
      size={size}
      color={color}
      style={{ width, fontWeight: 'normal' }}
    >
      {children}
    </MuiButton>
  );
};
